// extracted by mini-css-extract-plugin
export var quillEditor = "_pl-1";
export var variable = "_pl-0";